<div class="about-main-image" style="background-image: url('/assets/img/Top Banner Image.png'); background-size: cover">
    <div class="row padding-top-20 margin-bottom-5">
        <div class="col-md-1 col-sm-1"></div>
        <div class="col-md-8 col-sm-10 margin-left-10 margin-right-10">
            <h1 id="about-main-text-header">Your legal education starts here.</h1>
        </div>
        <div class="col-md-3 col-sm-1"></div>
    </div>
    <div class="row padding-bottom-10">
        <div class="col-md-1 col-sm-1"></div>
        <div class="col-md-6 col-sm-10 margin-left-10 margin-right-10">
            <h4 id="about-main-text-description">Whether you’re a student or professional whose job requires knowledge
                of the law, LawShelf’s comprehensive courses and easy-to-use research tools can help give you the edge
                you need to succeed. Produced by attorneys and law professors under the auspices of National Paralegal
                College, we’re here to help you learn about the law.</h4>
        </div>
        <div class="col-md-5 col-sm-1"></div>
    </div>
</div>
<div class="row padding-top-10 padding-bottom-30" style="background-color: #e4ebe9; color: #3f4962">
    <div class="col-xs-12 margin-top-40 padding-left-10 padding-right-10 text-align-center" style="width: 100%">
        <div class="block-center" style="margin: auto">
            <table style="margin: 0px auto;  ">
                <tr>
                    <td>
                        <img class="justice-image" src="/assets/img/scales of justice copy.png"
                            alt="Scales of Justice" />
                    </td>
                    <td>
                        <h1 style="font-size: calc(16px + (28 - 16) * ((100vw - 300px) / (1600 - 300))) !important;">
                            &nbsp; A project of National Paralegal College &nbsp;</h1>
                    </td>
                    <td>
                        <img class="justice-image" src="/assets/img/scales of justice copy.png"
                            alt="Scales of Justice" />
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="col-xs-10 padding-top-20 text-align-center padding-left-20 padding-right-20"
        style="font-size: calc(10px + (22 - 10) * ((100vw - 300px) / (1600 - 300)));">
        National Paralegal College has been a leader in online paralegal
        education since 2003, educating thousands of students in their pursuit
        of career enhancement and professional development. While not all
        LawShelf writers are also NPC faculty members, all LawShelf content
        goes through a comprehensive multi-tiered review process supervised
        by NPC faculty and administration.
    </div>
</div>
<div class="row">
    <div class="col-lg-6 col-md-12 margin-top-50" style="padding-right: 0px !important">

        <div class="embedded-video about-video">
            <iframe webkitallowfullscreen="" mozallowfullscreen="" allow="autoplay; fullscreen" allowfullscreen
                frameborder="0" src="//player.vimeo.com/video/370068625" width="640" height="360"
                class="note-video-clip" style="max-height: 480px"></iframe>
        </div>

    </div>
    <div class="col-lg-6 col-md-12" style="padding-left: 0px !important; ">
        <div class="padding-left-40 margin-top-50">
            <h1 class="about-title">Our video-courses are the heart of LawShelf.</h1>
        </div>
        <div class="margin-top-10 padding-left-40 margin-right-10 margin-bottom-10 about-description">
            Courses typically come with 4-6 animated video modules, each complete with practice multiple-choice
            questions to let you self-assess. When you finish a course, you can take a multiple-choice exam and earn a
            digital badge as a testament to your achievement.
        </div>
        <div class="margin-top-30 padding-left-40">
            <h1 class="about-title">Our hundreds of short videos are 5-to-10 minute animated presentations.</h1>
        </div>
        <div class="margin-top-10 padding-left-40 margin-right-10 margin-bottom-10 about-description">
            These videos are focused on the basics of legal concepts, such as Chapter 7 bankruptcy, real estate sales
            contracts and personal income tax filings.
        </div>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12" style="padding-right: 0px !important; padding-left: 30px; margin-bottom: 20px">
        <div class="margin-left-10 margin-right-20 padding-top-20">
            <h1 class="about-title">Our foundations of law section contains hundreds of plain-English articles.</h1>
        </div>
        <div class="margin-top-10 margin-left-10 margin-right-20 margin-bottom-10 about-description">
            These articles come loaded with hypothetical examples and cite cases and statutes for further research.
        </div>
        <div class="margin-top-30 padding-left-10">
            <h1 class="about-title">LawShelf has also created a comprehensive research index.</h1>
        </div>
        <div class="margin-top-10 padding-left-10 margin-right-20 margin-bottom-10 about-description">
            It references over 5,000 legal concepts and terms. Just find the term using our search box and we’ll show
            you precisely where on our site it’s covered. Use this feature when you’re in a hurry to learn about a
            particular concept. You can always take in the full lessons when you have a bit more time.
        </div>
    </div>
</div>

<div class="row padding-top-10 padding-bottom-30" style="background-color: #e4ebe9; color: #3f4962;">
    <div class="col-xs-12 margin-top-20 margin-bottom-5 padding-left-10 padding-right-10 text-align-center"
        style="width: 100%">
        <div class="block-center" style="margin: auto">
            <table style="margin: 0px auto;  ">
                <tr>
                    <td>
                        <img class="justice-image" src="/assets/img/scales of justice copy.png"
                            alt="Scales of Justice" />
                    </td>
                    <td>
                        <h1 style="font-size: calc(16px + (28 - 16) * ((100vw - 300px) / (1600 - 300)));">&nbsp; Best of
                            all, it’s completely free!&nbsp;</h1>
                    </td>
                    <td>
                        <img class="justice-image" src="/assets/img/scales of justice copy.png"
                            alt="Scales of Justice" />
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="col-xs-1 padding-top-20"></div>
    <div class="col-xs-10 padding-top-20 text-align-center padding-left-20 padding-right-20"
        style="font-size: calc(10px + (22 - 10) * ((100vw - 300px) / (1600 - 300)));">
        Be sure to let us know if you’d like to partner with us to provide legal education or research solutions for
        your school, organization or user base. And please reach out with any questions or feedback on where we can do
        better.
    </div>
</div>
<div class="padding-bottom-20 padding-top-10 padding-left-20 padding-right-20"
    style="font-size: calc(12px + (22 - 12) * ((100vw - 300px) / (1600 - 300)));">
    <br />
    <h1 style="color: #6ca3a1; font-size: calc(14px + (28 - 14) * ((100vw - 300px) / (1600 - 300)));">Our writing
        staff...</h1>
    <strong>...are attorneys and professors who have experience in teaching and practicing law.</strong> They are chosen
    based on their writing and teaching skills and for expertise in their given subjects. LawShelf has employed a wide
    variety of expert contributors and the people referenced below represent our most prolific contributors. If you
    would like to write for LawShelf and you are an experienced attorney, writer and/or law professor, please send us
    your resume and a writing sample.
    <br />
    <br />
    <br />
    <strong>Susan Calistri Boesger</strong> has over 25 years of experience in wills, trusts, estates and tax law. She
    has also been a legal writer for ten years with LexisNexis/Matthew Bender, writing professional manuals and consumer
    articles. She taught as an adjunct professor for many years at St. Petersburg College (Florida) where she developed
    and taught various courses. Susan holds a J.D. and LLM in Estate Planning from the University of Miami School of
    Law.
    <br />
    <br />
    <strong>Jessica Borden</strong> is a long-time professor of law at National Paralegal College, earned her J.D. from
    the University of Pennsylvania Law School, where she was an associate editor of the Constitutional Law Journal. She
    is admitted to the bar in New York, Connecticut and Florida. Jessica practiced litigation at Willkie Farr and
    Gallagher LLP, real estate law at Schiff Hardin LLP and in-house product liability law at a large Connecticut-based
    pharmaceutical company.
    <br />
    <br />
    <strong>Donald F. Ferland</strong> is a law professor at Massachusetts Bay Community College and has taught at other
    colleges and universities. He also worked as an Attorney-Advisor/Curriculum Developer in the U.S. Department of
    Defense/Defense Institute of International Legal Studies and was awarded the DSCA World of Excellence Award by the
    Pentagon. In addition to his JD from University of Connecticut School of Law and LLM from Boston University School
    of Law, he holds master’s degrees in American History from Providence College and instructional design from
    University of Massachusetts. He also has extensive experience in creation and design of educational tools.
    <br />
    <br />
    <strong>Anthony Fata</strong> has extensive law practice experience in the areas of securities, commodities,
    derivatives and corporate law. As a law professor at Seton Hall University College of Law, he taught courses in
    Securities Regulation, Corporate Finance, Corporate Governance and Corporate Formation. Anthony has also presented
    at multiple seminars on the subject of Internal Investigations. As a partner at the Chicago law firm, Cafferty
    Clobes Meriwether & Sprengel LLP, Anthony helps investors, traders, brokers and advisors solve difficult regulatory
    and litigation problems.
    <br />
    <br />
    <strong>Samantha Joule Fow’s</strong> professional writing career is a natural extension of her passion for
    teaching, learning from and connecting with others. After completing her undergraduate studies in economics,
    Samantha earned her J.D., a Master’s in Energy Regulation and Law and LL.M in Environmental Law from Vermont Law
    School. Samantha founded technical and content writing company Axiom Communications in 2017. In additional to
    generating high-quality technical writing for enterprise and education, Samantha regularly publishes blogs and
    editorials focused how law and society co-evolve in our quickly changing world. Her publications include her
    official blog, other articles and a law review article published in the Vermont Journal of Environmental Law.
    <br />
    <br />
    <strong>Robert L. Greenberg</strong> received his law degree from the University of Michigan, his Master of Science
    in Electrical and Computer Engineering from Rutgers University and his Bachelor of Arts Magna Cum Laude with High
    Honors in Economics from Brandeis University. He runs his own law firm in New York. In addition to his firm, he
    serves as a Major/Judge Advocate in the New York Guard where he provides free legal services for soldiers, sailors,
    airmen, marines, coast guardsmen and their families. He is admitted to practice law in New York, New Jersey, and
    Texas, and is also a registered patent attorney.
    <br />
    <br />
    <strong>Stephen Haas</strong> is Director of Education for National Paralegal College. He has served in that
    capacity since 2003, having led the development of the school’s curriculum throughout its history. Stephen has also
    practiced law in the areas of estate planning, real estate and taxation. He graduated in the top 3% of his class
    from Pace University School of Law. He is the co-author of Basic Trust Drafting. Stephen is a regular presenter
    education conferences, having presented at conferences held by the Distance Education Accrediting Commission, United
    States Distance Learning Association and the University of Wisconsin Extension Distance Teaching and Learning
    conference.
    <br />
    <br />
    <strong>Alexander Lake</strong> has an undergraduate degree in journalism and a J.D. from University of Oregon. He
    has over 30 years of experience as an attorney and professional writer. As a contract administrator for Oregon
    Ballistic Laboratories, Alexander negotiates, drafts and oversees contracts with governmental and private partners.
    His other writing projects have included creating training materials for Fred Meyer Stores in Portland, OR. His law
    practice experience includes representation of businesses in domestic and international contracts and business
    matters.
    <br />
    <br />
    <strong>Jeremy Rovinsky</strong> serves as Dean at National Paralegal College. He graduated with honors from the
    George Washington University Law School in Washington, DC. Before attending law school, Mr. Rovinsky was awarded a
    Dean's scholarship to study at American University in Washington, DC, graduated magna cum laude with joint degrees
    in Philosophy and Political Science and was made a member of the Phi Beta Kappa honor society. Jeremy has worked in
    the New York State Assembly, the US Congress, the US Senate and the Department of Justice, and in private law
    offices in New York, Washington and overseas. He worked directly under the General Counsel at the DC Office of Human
    Rights. Jeremy is been admitted to practice law in a number of jurisdictions and has been published in multiple law
    reviews and legal journals, such as the Brigham Young University Education and Law Journal and the Rutgers Conflict
    Resolution Law Journal. He has also taught upper-level legal courses at an ABA-accredited law school, helped update
    the Rules of Professional Conduct for an American Indian Community Court and served as a Judge Pro Tem at the
    Maricopa County Justice Courts.
    <br />
    <br />
    <strong>Elliot Stern</strong> earned his JD from the Georgetown University Law Center, and has extensive experience
    in legal writing and research in a variety of contexts, including serving as a legal editor for the NY State
    Department of Health, a law clerk for the Federal employment agency, the US Merit Systems Protection Board as well
    as a speechwriter for a UN ambassador. As a researcher and writer, Elliot has a unique ability to synthesize diffuse
    and complex material into clear and accessible prose and produce courses that reflect the reasoned judgment of
    multiple contributors. Elliot has also created and updated law courses for Marino Legal Academy.
    <br />
    <br />
    <strong>Richard Weiner</strong> is a prolific writer who is a staff writer for the Akron Legal News. He has also
    writtern extensively for Chicago Lawyer Magazine the Cleveland Plain Dealer M&A Journal (in Yonkers, NY), Crain’s
    and many others. He taught law and English courses at Kent State University and has more than a decade of law
    practice experience in areas of personal injury, family law, criminal law and bankruptcy. He holds a J.D. from Ohio
    Northern University.
    <br />
    <br />
    <strong>Erika Winston</strong> is an attorney and professional writer and copy editor. She has published articles
    for the websites of the DC Bar, Urban Views Weekly and various newspapers and law firm websites. In addition to her
    J.D., she holds a master’s degree in public policy from New England College. Before becoming a professional writer,
    she practiced law as a sole practitioner, handling matters of criminal law, domestic relations and housing. She is
    also a professor of political science in the Virginia Community College system.
    <br />
    <br />
</div>
<div class="padding-top-50 padding-bottom-50 padding-left-40 padding-right-40"
    style="background-color: #e4ebe9;font-size: calc(12px + (22 - 12) * ((100vw - 300px) / (1600 - 300))); margin-bottom: -30px">
    <br />
    <strong>Your privacy is important to us.</strong> While we automatically collect certain non-personally identifiable
    information when you visit our website, including, but not limited to, the type of browser you are using, the type
    of operating system you are using, and the domain name of your Internet service provider, the only personal
    information that we ever ask for is your name and email address, which we ask for during the registration process.
    You need to register only if you would like to earn digital badges or receive communications from us. You do not
    need to register to use the site.
    <br />
</div>